import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import RcTree from './Tree';
import TreeNode from './TreeNode';
import animation from './openAnimation';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
var TreeProps = {
  showLine: PropTypes.bool,
  className: PropTypes.string,

  /** 是否支持多选 */
  multiple: PropTypes.bool,

  /** 是否自动展开父节点 */
  autoExpandParent: PropTypes.bool,

  /** checkable状态下节点选择完全受控（父子节点选中状态不再关联）*/
  checkStrictly: PropTypes.bool,

  /** 是否支持选中 */
  checkable: PropTypes.bool,

  /** 默认展开所有树节点 */
  defaultExpandAll: PropTypes.bool,

  /** 默认展开指定的树节点 */
  defaultExpandedKeys: PropTypes.array,

  /** （受控）展开指定的树节点 */
  expandedKeys: PropTypes.array,

  /** （受控）选中复选框的树节点 */
  checkedKeys: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** 默认选中复选框的树节点 */
  defaultCheckedKeys: PropTypes.array,

  /** （受控）设置选中的树节点 */
  selectedKeys: PropTypes.array,

  /** 默认选中的树节点 */
  defaultSelectedKeys: PropTypes.array,

  /** 展开/收起节点时触发 */
  onExpand: PropTypes.func,

  /** 点击复选框触发 */
  onCheck: PropTypes.func,

  /** 点击树节点触发 */
  onSelect: PropTypes.func,

  /** filter some AntTreeNodes as you need. it should return true */
  filterAntTreeNode: PropTypes.func,

  /** 异步加载数据 */
  loadData: PropTypes.func,

  /** 响应右键点击 */
  onRightClick: PropTypes.func,

  /** 设置节点可拖拽（IE>8）*/
  draggable: PropTypes.bool,

  /** 开始拖拽时调用 */
  onDragStart: PropTypes.func,

  /** dragenter 触发时调用 */
  onDragEnter: PropTypes.func,

  /** dragover 触发时调用 */
  onDragOver: PropTypes.func,

  /** dragleave 触发时调用 */
  onDragLeave: PropTypes.func,

  /** drop 触发时调用 */
  onDrop: PropTypes.func,
  style: React.CSSProperties,
  clsPrefix: PropTypes.string,
  filterTreeNode: PropTypes.func
};
var defaultProps = {
  clsPrefix: 'u-tree',
  checkable: false,
  showIcon: false,
  openAnimation: animation
};
var Tree = (_dec = WebUI({
  name: "tree",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Tree, _Component);

  var _super = _createSuper(Tree);

  function Tree() {
    _classCallCheck(this, Tree);

    return _super.apply(this, arguments);
  }

  _createClass(Tree, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var checkable = props.checkable;
      return /*#__PURE__*/React.createElement(RcTree, _extends({}, props, {
        checkable: checkable ? /*#__PURE__*/React.createElement("span", {
          className: "".concat(props.clsPrefix, "-checkbox-inner")
        }) : checkable
      }), this.props.children);
    }
  }]);

  return Tree;
}(Component)) || _class);
Tree.TreeNode = TreeNode;
Tree.TreeProps = TreeProps;
export default Tree;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tree/src/index.js